var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name === 'Error404')?_c('div',[_c('Error')],1):_c('div',[_c('Header'),(_vm.loader)?_c('Loader'):_vm._e(),_c('router-view',{attrs:{"fixNumber":_vm.fixNumber}}),_c('CookieLaw'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }